// extracted by mini-css-extract-plugin
export var closeButton = "_q0-2";
export var closeButtonIcon = "_q0-3";
export var lightboxContent = "_q0-1";
export var lightboxOverlay = "_q0-0";